// extracted by mini-css-extract-plugin
module.exports = {"root":"LazyImage_root__8zERk","image":"LazyImage_image__OX08j"};